import { render, staticRenderFns } from "./Frameworks.vue?vue&type=template&id=c43b70f4&"
import script from "./Frameworks.vue?vue&type=script&lang=js&"
export * from "./Frameworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports